import Animations from "animations";

class DynamicProductSearch extends HTMLElement {
  #e;
  #t;
  #r;
  
  constructor() {
    super();
    this.#e = this.#n.bind(this);
    this.#t = this.#s.bind(this);
    this.#r = this.#i.bind(this);
  }

  connectedCallback() {
    this.abortController = null;
    this.listeners = [];
    this.section = this.closest(".section");
    this.updateLoading();
    this.#o();
    window.addEventListener("popstate", this.#r);
  }

  disconnectedCallback() {
    this.#l();
    window.removeEventListener("popstate", this.#r);
  }

  renderError(e = window.theme.localize("ERROR_PRODUCTS")) {
    if (this.previousElementSibling && this.previousElementSibling.classList.contains("error")) {
      this.previousElementSibling.remove();
    }
    const t = document.createElement("div");
    t.classList.add("error");
    t.innerHTML = e;
    if (this.section) {
      this.section.prepend(t);
    }
  }

  renderCollection(e) {
    const { query: t, updateURL: r, scrollUp: n } = { query: "", updateURL: true, scrollUp: false, ...e };
    const s = document.activeElement && document.activeElement.getAttribute("id");
    const i = `.section--${this.dataset.section}`;
    
    this.abortController = new AbortController();
    this.updateLoading(true);

    fetch(`${this.dataset.url}?${t}&section_id=${this.dataset.section}`, { signal: this.abortController.signal })
      .then((response) => {
        if (response.ok) return response.text();
        throw new Error(window.theme.localize("ERROR_PRODUCTS"));
      })
      .then((html) => {
        this.dispatchEvent(new CustomEvent("on:dynamic-product-search:loading"));
        
        let scrollPos = 0;
        const predictiveSearch = this.querySelector("predictive-search");
        if (predictiveSearch) predictiveSearch.close();
        
        const filtersModal = this.querySelector('.modal--filters:not([aria-hidden="true"])');
        if (filtersModal) {
          const wrapper = filtersModal.querySelector(".collection-sidebar__wrapper");
          if (wrapper) scrollPos = wrapper.scrollTop;
        }

        const doc = new DOMParser().parseFromString(html, "text/html");
        const container = document.querySelector(i);
        const parsedSection = doc.querySelector(i);
        
        if (parsedSection && container) {
          this.#l();
          const oldContent = container.querySelector(".js-main-content");
          const newContent = parsedSection.querySelector(".js-main-content");

          if (oldContent.children.length > 0 && newContent.children.length > 0) {
            const totalResultsOld = container.querySelector(".js-results-total");
            const totalResultsNew = parsedSection.querySelector(".js-results-total");

            if (totalResultsOld && totalResultsNew) {
              totalResultsOld.innerHTML = totalResultsNew.innerHTML;
            }

            const sortFormOld = container.querySelector(".js-sort-form");
            const sortFormNew = parsedSection.querySelector(".js-sort-form");
            if (sortFormOld && sortFormNew) sortFormOld.innerHTML = sortFormNew.innerHTML;

            const activeFiltersOld = container.querySelector(".js-active-filters");
            const activeFiltersNew = parsedSection.querySelector(".js-active-filters");
            if (activeFiltersOld && activeFiltersNew) activeFiltersOld.innerHTML = activeFiltersNew.innerHTML;

            const filtersOld = container.querySelector(".js-filters");
            const filtersNew = parsedSection.querySelector(".js-filters");
            if (filtersOld && filtersNew) filtersOld.innerHTML = filtersNew.innerHTML;

            const actionsOld = container.querySelector(".js-actions");
            const actionsNew = parsedSection.querySelector(".js-actions");
            if (actionsOld && actionsNew) actionsOld.innerHTML = actionsNew.innerHTML;

            const resultsContainerOld = container.querySelector(".js-results-container");
            const resultsContainerNew = parsedSection.querySelector(".js-results-container");
            if (resultsContainerOld && resultsContainerNew) {
              resultsContainerOld.innerHTML = resultsContainerNew.innerHTML;
            }

            const paginationOld = container.querySelector(".js-pagination");
            const paginationNew = parsedSection.querySelector(".js-pagination");
            if (paginationOld && paginationNew) paginationOld.innerHTML = paginationNew.innerHTML;
          } else {
            const sectionTitleOld = container.querySelector(".js-section-title");
            const sectionTitleNew = parsedSection.querySelector(".js-section-title");
            if (sectionTitleOld && sectionTitleNew) sectionTitleOld.innerHTML = sectionTitleNew.innerHTML;

            const mainContentOld = container.querySelector(".js-main-content");
            const mainContentNew = parsedSection.querySelector(".js-main-content");
            if (mainContentOld && mainContentNew) mainContentOld.innerHTML = mainContentNew.innerHTML;
          }

          this.#o();
        }

        Animations.setup(document.querySelector(i));

        if (filtersModal) {
          const wrapper = filtersModal.querySelector(".collection-sidebar__wrapper");
          if (wrapper && scrollPos !== 0) wrapper.scrollTop = scrollPos;
        }

        if (n) this.scrollUp();
        const pageTitle = document.querySelector(`${i} dynamic-product-search`).dataset.pageTitle;
        r && this.updateURL(t, pageTitle);
        document.title = pageTitle;
        this.updateLoading(false);

        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init && this.dataset.quickShopDynamicCheckout === "true") {
          window.Shopify.PaymentButton.init();
        }

        const activeElement = document.getElementById(s);
        if (activeElement) activeElement.focus();
        this.dispatchEvent(new CustomEvent("on:dynamic-product-search:loaded"));
      })
      .catch(async (error) => {
        if (error.name && error.name === "AbortError") return;

        this.updateLoading(false);
        this.renderError(error);

        const filtersModal = this.querySelector('.modal--filters:not([aria-hidden="true"])');
        if (filtersModal) await filtersModal.close();

        this.scrollUp();
        this.dispatchEvent(new CustomEvent("on:dynamic-product-search:failed"));
      });
  }

  scrollUp() {
    const { top } = this.section.getBoundingClientRect();
    window.scrollBy({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
      top,
    });
  }

  updateLoading(isLoading = false) {
    this.loading = isLoading;
    if (isLoading) {
      this.section.classList.add("is-loading");
    } else {
      this.section.classList.remove("is-loading");
    }
  }

  updateURL(query, title = "") {
    if (this.dataset.updateUrl !== "false") {
      window.history.pushState({}, title, `${this.dataset.url}${query ? `?${query}` : ""}`);
    }
  }

  #i() {
    const query = window.location.search.slice(1);
    this.renderCollection({ updateURL: false, query });
  }

  #n(event, scrollUp = false) {
    event.preventDefault();
    if (!event.target.getAttribute("href") && !event.target.dataset.url) return;

    const url = event.target.getAttribute("href") || event.target.dataset.url;
    const query = url.split("?").length > 0 ? url.split("?")[1] : "";

    this.renderCollection({ query, scrollUp });
  }

  #s(event) {
    this.#n(event, true);
  }

  #a() {
    this.querySelectorAll(".js-filter-trigger").forEach((element) => {
      element.addEventListener("click", this.#e);
      this.listeners.push({ element, event: "click", handler: this.#e });
    });
  }

  #c() {
    this.querySelectorAll(".pagination a").forEach((element) => {
      element.addEventListener("click", this.#t);
      this.listeners.push({ element, event: "click", handler: this.#t });
    });
  }

  #o() {
    this.forms = [this.querySelector(".js-search-form"), this.querySelector(".js-sort-form"), this.querySelector(".js-filters-form")]
      .filter((form) => form);

    this.querySelector(".js-search-form") && this.querySelector(".js-filters-form") && this.querySelector('.js-filters-form input[name="q"]').remove(),
            this.forms.forEach((e) => {
                "true" === e.dataset.submitOnChange &&
                    e.addEventListener("change", () => {
                        e.requestSubmit();
                    }),
                    e.addEventListener("submit", (e) => {
                        e.preventDefault(), this.abortController && this.abortController.abort();
                        let t = "";
                        if (e.target.classList.contains("js-search-form")) {
                            const e = ["type", "q", "sort_by"];
                            t = this.forms.reduce((t, r) => {
                                const n = new FormData(r);
                                for (const [t] of n.entries()) e.includes(t) || n.delete(t);
                                const s = new URLSearchParams(n).toString();
                                return `${t}${s ? `${t ? "&" : ""}${s}` : ""}`;
                            }, "");
                        } else
                            t = this.forms.reduce((e, t) => {
                                const r = new FormData(t),
                                    n = new URLSearchParams(r).toString();
                                return `${e}${n ? `${e ? "&" : ""}${n}` : ""}`;
                            }, "");
                        this.renderCollection({ query: t });
                    });
            }),
            this.#a(),
            this.#c();
    }
    #l() {
        this.listeners.forEach(({ element: e, event: t, handler: r }) => {
            e.removeEventListener(t, r);
        });
    }
}
customElements.define("dynamic-product-search", DynamicProductSearch);
//# sourceMappingURL=dynamic-product-search.js.map
